import React,{useContext} from 'react'
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import '../cssfiles/Navbar1.css'
import Cart from 'react-bootstrap-icons/dist/icons/cart'
import {Link,useNavigate} from "react-router-dom";
import { AuthContext } from '../context/context';
import { Firebase } from '../components/config';
import { CartState } from "../context/contextmen";
import Badge from 'react-bootstrap/Badge';





function Navbar1() {
  const {state: { cart }, productDispatch} = CartState();
  const navigate = useNavigate()
  const {user} = useContext(AuthContext)
return(
<Navbar style={{backgroundColor:"grey"}} expand="lg" sticky='top'>
<Container fluid>
  <Navbar.Brand href="#" varient="light" ><span className='brand'>H20</span>
        </Navbar.Brand>
  <Navbar.Toggle aria-controls="navbarScroll" />
  <Navbar.Collapse id="navbarScroll">
    <Nav
      className="me-auto my-2 my-lg-0 routei"
      style={{ maxHeight: '500px',
      width: "50%",
      border: "0",
      padding: "10px" }}
      navbarScroll
    >
      <Nav.Link as={Link} to = {'/'} id="hi">Home</Nav.Link>
      <Nav.Link as={Link} to = {'/Login'}id="hi">Login/Signup</Nav.Link>
      <Nav.Link as={Link} to = {'/Men'}id="hi">Mens</Nav.Link>
      <Nav.Link as={Link} to = {'/Women'}id="hi">Women</Nav.Link>
      <Nav.Link as= {Link} to ={'/Addtocart'}> <Cart className="bi bi-cart"/>
      <Badge bg="danger">{cart.length}</Badge></Nav.Link>
   <Nav.Link>Hello{user ? ":" +user.displayName: ""}</Nav.Link>
    {user &&<Nav.Link onClick={()=>{
      Firebase.auth().signOut();
      navigate('/Login')
    }}>Logout</Nav.Link>}
     </Nav >
    <Form className="d-flex form1 brand search">
      <Form.Control
        type="search"
        placeholder="Search"
        className="me-2"
        aria-label="Search"
        onChange={(e) => {
          productDispatch({
            type: "FILTER_BY_SEARCH",
            payload: e.target.value,
          });
        }}
      />
      
    </Form>
    
    
  </Navbar.Collapse>
</Container>
</Navbar>

)}

  
  
    

export default Navbar1